"use client"

import clsx from "clsx"
import { FC } from "react"
import { localizeText } from "src/localization/utils"
import { StorefrontVariantOption } from "src/types/storefront"

export type OptionSelectProps = {
  option: StorefrontVariantOption
  selectedValueName: string | undefined
  onValueClick: (optionId: string, valueName: string) => void
  disabled: boolean
}

export const OptionSelect: FC<OptionSelectProps> = ({ option, selectedValueName, onValueClick, disabled }) => {
  const T = localizeText(text)

  return (
    <div className="flex flex-col gap-2">
      <div>{option.name}</div>

      <div className="flex flex-wrap justify-start gap-2">
        {option.values.map((value) => {
          const selected = value.name === selectedValueName

          return (
            <button
              key={value.name}
              type="button"
              onClick={() => onValueClick(option.id, value.name)}
              className={clsx(
                "relative flex h-10 flex-1 items-center justify-center overflow-hidden rounded-full border bg-gray-100 px-6 py-2 text-sm font-normal whitespace-nowrap",
                {
                  "border-brand-primary": selected,
                  "hover:shadow-elevation-card-rest transition-shadow duration-150 ease-in-out": !selected,
                },
              )}
              disabled={disabled}
            >
              {value.purchasable ? (
                value.name
              ) : (
                <div className="flex flex-col items-center justify-center opacity-50">
                  <div className="text-xs line-through">{value.name}</div>
                  <div className="text-subtle text-[0.5rem] uppercase">{T.outOfStock}</div>
                </div>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}

const de = {
  outOfStock: "Ausverkauft",
}

const en: typeof de = {
  outOfStock: "Out of stock",
}

const text = { de, en }
